<script setup lang="ts">
import { PropType } from 'vue';
import { MenuRouterBindProps } from 'primevue/menu';
import { AppMainMenuItem } from '../../stores/core/models';

defineEmits(['click']);

defineProps({
  item: {
    type: Object as PropType<AppMainMenuItem>,
    required: true,
  },
  menuProps: {
    type: Object as PropType<MenuRouterBindProps>,
  },
});
</script>
<template>
  <div
    class="flex items-center dark:hover:!bg-gray-800 rounded-md"
    v-ripple
    v-bind="menuProps!.action"
    :class="{ '!cursor-not-allowed dark:!text-gray-500': item.disabled, 'dark:!text-gray-100': !item.disabled }"
    @click="$emit('click', $event)"
  >
    <!------------------------
    -- Regular Toolbar Item --
    -------------------------->
    <img :src="item.iconImg" :class="{ 'app-filter-disabled': item.disabled }" v-if="item.iconImg" />
    <span :class="item.icon" v-if="item.icon" />
    <span v-if="item.label" class="ml-2">{{ $t((item as any).label) }}</span>
  </div>
</template>
